import React from 'react';
import './LegalPage.css';

const Cookies = () => {
  return (
    <div className="legal-page">
      <h1>AVISO LEGAL Y POLÍTICA DE COOKIES</h1>

      <section>
        <h2>1. Titularidad del sitio web</h2>
        <p>
          En cumplimiento de la Ley 29/2021, de protección de datos personales, y la Ley 35/2014, de servicios electrónicos de confianza y del comercio electrónico del Principado de Andorra, se informa que este sitio web es titularidad de:
        </p>
        <p>
          DMG BSNS SLU<br />
          Avinguda Príncep Benlloch, 26-30, Edifici Clara Rabassa, Taula C39 AD500 Andorra la Vella <br />
          NRT: L-719268-A<br />
          Correo de contacto: <a href="mailto:ceocloseracademy@gmail.com">ceocloseracademy@gmail.com</a><br />
          Sitio web: <a href="https://landing.closeracademy.app" target="_blank" rel="noopener noreferrer">https://landing.closeracademy.app</a>
        </p>
      </section>

      <section>
        <h2>2. Condiciones de uso</h2>
        <p>
          El acceso a este sitio web le otorga la condición de Usuario, lo que implica la aceptación plena de las condiciones contenidas en este Aviso Legal.
        </p>
        <p>
          Si no está de acuerdo con alguna de estas condiciones, debe abstenerse de utilizar el sitio web.
        </p>
        <p>
          El simple acceso al sitio no implica, en ningún caso, el inicio de una relación comercial entre el Usuario y el Titular.
        </p>
        <p>
          El Usuario se compromete a utilizar el sitio web de forma lícita, respetuosa y conforme a la legislación vigente.
        </p>
      </section>

      <section>
        <h2>3. Propiedad intelectual e industrial</h2>
        <p>
          Todos los contenidos del sitio web (textos, imágenes, logotipos, diseños, software, código fuente, etc.) son propiedad del Titular o de terceros licenciantes, y están protegidos por la legislación de propiedad intelectual e industrial.
        </p>
        <p>
          Queda prohibida su reproducción, distribución, comunicación pública o modificación sin autorización expresa y por escrito del Titular.
        </p>
      </section>

      <section>
        <h2>4. Enlaces a sitios web de terceros</h2>
        <p>
          Este sitio web puede contener enlaces a páginas externas con fines informativos. El Titular no se hace responsable de los contenidos, políticas o prácticas de dichos sitios.
        </p>
        <p>
          El hecho de incluir enlaces no implica relación alguna entre el Titular y los responsables de dichos sitios.
        </p>
        <p>
          Se recomienda al Usuario leer las políticas de privacidad y condiciones de uso de los sitios enlazados.
        </p>
      </section>

      <section>
        <h2>5. Limitación de responsabilidad</h2>
        <p>
          El Titular no garantiza la disponibilidad continua ni la ausencia de errores en el sitio web.
        </p>
        <p>
          Tampoco se hace responsable por daños directos o indirectos derivados del uso del sitio, interrupciones del servicio, fallos técnicos o virus informáticos, pese a que se adoptan todas las medidas necesarias para evitarlos.
        </p>
      </section>

      <section>
        <h2>6. Uso de cookies</h2>

        <h3>¿Qué son las cookies?</h3>
        <p>
          Las cookies son archivos pequeños que se descargan y almacenan en el navegador del Usuario al acceder a determinadas páginas web. Sirven para garantizar el funcionamiento del sitio, mejorar la experiencia del Usuario y recopilar datos estadísticos anónimos sobre navegación.
        </p>

        <h3>Tipos de cookies utilizadas</h3>
        <ul>
          <li>Cookies técnicas: necesarias para el funcionamiento básico y la navegación del sitio.</li>
          <li>Cookies de análisis: permiten medir la actividad de los usuarios en el sitio con fines estadísticos.</li>
          <li>Cookies de terceros: instaladas por servicios externos integrados en el sitio.</li>
        </ul>

        <h3>Cookies utilizadas en este sitio</h3>
        <ul>
          <li><strong>Google Analytics:</strong> para recopilar información anónima sobre el uso del sitio (duración de visitas, páginas más vistas, etc.).</li>
          <li><strong>Hotmart:</strong> plataforma de venta de productos digitales, que puede instalar cookies técnicas o de seguimiento.</li>
          <li><strong>Facebook Ads:</strong> para fines publicitarios y de remarketing.</li>
        </ul>

        <h3>Gestión de cookies</h3>
        <p>El Usuario puede aceptar, bloquear o eliminar las cookies instaladas mediante la configuración de su navegador. Las instrucciones específicas para los principales navegadores son:</p>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
          <li><a href="https://support.mozilla.org/es/kb/Eliminar%20cookies" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
          <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
          <li><a href="https://support.microsoft.com/es-es/help/4027947" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
        </ul>

        <h3>Consentimiento del Usuario</h3>
        <p>
          Al acceder a este sitio web, el Usuario ha sido informado sobre el uso de cookies y se le ha ofrecido la posibilidad de aceptarlas o configurarlas mediante el correspondiente banner de consentimiento.
        </p>
      </section>

      <section>
        <h2>7. Legislación aplicable y jurisdicción</h2>
        <p>
          Este Aviso Legal y el uso del sitio web se rigen por la legislación vigente del Principado de Andorra.
        </p>
        <p>
          Asimismo, para garantizar la protección de los datos de usuarios que accedan desde el Espacio Económico Europeo, el Titular se compromete a respetar de forma voluntaria los principios y derechos recogidos en el Reglamento General de Protección de Datos (RGPD).
        </p>
      </section>

      <section>
        <h2>8. Contacto</h2>
        <p>
          Si tiene cualquier duda sobre este Aviso Legal o el uso del sitio web, puede escribir a: <a href="mailto:ceocloseracademy@gmail.com">ceocloseracademy@gmail.com</a>
        </p>
      </section>
    </div>
  );
};

export default Cookies;
